import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';

const ClassDialog = ({
  visible,
  onHide,
  editingClass,
  classForm,
  setClassForm,
  classNameOptions,
  dialogClassNameValue,
  setDialogClassNameValue,
  availableSubjects,
  selectedSubjectIds,
  onSubjectToggle,
  saveClass
}) => {
  const footer = (
    <div className="flex justify-between items-center mt-4">
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all" />
      <Button label={editingClass ? 'Update' : 'Create'} icon="pi pi-check" onClick={saveClass} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg px-4 py-2 shadow-md hover:shadow-lg transition-all" />
    </div>
  );

  return (
    <Dialog header={editingClass ? 'Edit Class' : 'Create Class'} visible={visible} onHide={onHide} style={{ width: 520 }} footer={footer}>
      <div className="p-2 space-y-3">
        <div>
          <label className="block text-sm">Select Class:</label>
          <Dropdown value={dialogClassNameValue} options={classNameOptions} onChange={(e) => { 
            setDialogClassNameValue(e.value); 
            setClassForm((p) => ({ ...p, name: e.value })); 
          }} placeholder="Choose class" className="w-full" />
        </div>
        <div>
          <label className="block text-sm">Description (optional):</label>
          <InputTextarea className="w-full" value={classForm.description} onChange={(e) => setClassForm((p) => ({ ...p, description: e.target.value }))} rows={3} placeholder='Enter Description' />
        </div>
        <div>
          <label className="block text-sm mb-2">Choose Subjects:</label>
          <div className="grid grid-cols-1 gap-2 max-h-48 overflow-y-auto p-2 border rounded">
            {availableSubjects.length === 0 ? (
              <div className="text-sm text-gray-500">No subjects available.</div>
            ) : (
              availableSubjects.map((sub) => (
                <div key={sub.id} className="flex items-center">
                  <Checkbox inputId={`sub-${sub.id}`} checked={selectedSubjectIds.includes(sub.id)} onChange={(e) => onSubjectToggle(e, sub)} />
                  <label htmlFor={`sub-${sub.id}`} className="ml-2 text-sm">{sub.name}</label>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ClassDialog;
